import * as React from "react";
import { useRouter } from "next/router";
import Bugsnag from "@bugsnag/js";
import {
  fetchFAQ,
  IArticle,
  IFaqCategoryName,
} from "@nju/data-access-portal-help";
import { portalRoutes } from "@nju/routes";
import { Loader, Markdown } from "@nju/ui";
import { BlockContent, GeneralErrorNotification } from "@nju/ui";

type IStates = "IDLE" | "LOADING" | "ERROR" | "DONE";

interface ICMSArticleProps {
  categoryId: IFaqCategoryName;
}

export function CMSArticle({ categoryId }: ICMSArticleProps) {
  const [currentState, setCurrentState] = React.useState<IStates>("IDLE");
  const [article, setArticle] = React.useState<IArticle | undefined>();
  const router = useRouter();

  React.useEffect(() => {
    setCurrentState("LOADING");

    fetchFAQ({ categoryId }).then((result) => {
      if (result.isOk) {
        setArticle(result.value?.[0]?.articles[0]);

        if (result.value?.[0]?.articles.length === 0) {
          Bugsnag.notify(`No articles for category: ${categoryId}`);
        }

        return setCurrentState("DONE");
      }

      return setCurrentState("ERROR");
    });
  }, [categoryId]);

  if (currentState === "IDLE" || currentState === "LOADING") {
    return <Loader />;
  }

  if (currentState === "ERROR" || (currentState === "DONE" && !article)) {
    return (
      <BlockContent
        border="none"
        grid="narrow"
        rounded="primary"
        spacing="l"
        tone="none"
      >
        <GeneralErrorNotification
          callback={() => {
            router.push(portalRoutes.index.get());
          }}
        />
      </BlockContent>
    );
  }

  if (!article) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <Markdown
      as="div"
      className="prose"
      content={article.content.pl}
      key={article.articleId}
    />
  );
}
